module.exports = __webpack_public_path__ + "static/img/Roboto-Thin.ef17620.svg";